import {PLAY_MONEY} from 'app/utils/Consts';

export const isPlayMoney = (type: string) : boolean => type === PLAY_MONEY;
